import {useMutation, useQueryClient} from '@tanstack/react-query';

import {
  updateParticipantNames,
  UpdateParticipantNamesParams,
  upsertParticipantInfo,
  UpsertParticipantInfoParams,
  updateParticipantLocalizedName,
  UpdateParticipantLocalizedNameParams,
} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';

export const useUpdateParticipantNames = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateParticipantNamesParams) =>
      updateParticipantNames(params),
    onSuccess: (_data, {participantId}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__PARTICIPANTS, participantId],
      });
    },
  });
};

export const useUpsertParticipantInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpsertParticipantInfoParams) =>
      upsertParticipantInfo(params),
    onSuccess: (_data, {participantId}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__PARTICIPANTS, participantId],
      });
    },
  });
};

export const useUpdateParticipantLocalizedName = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateParticipantLocalizedNameParams) =>
      updateParticipantLocalizedName(params),
    onSuccess: (_data, {participantId}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__PARTICIPANTS, participantId],
      });
    },
  });
};
